<template>
</template>
<script>
    import router from '@/router'
    import store from '@/store'
    export default {
        name: 'logout',
        mounted () {
            localStorage.removeItem('token')
            store.commit('LOGOUT_USER')
            router.push('/')
        }
    }
</script>


// WEBPACK FOOTER //
// Logout.vue?91cf4d2a